import { useQuery } from '@tanstack/react-query';

import { useApiClient } from '../ApiClientProvider';
import { queryKeys } from '../keys';
import type { DeliveryCatalog } from '../types/services';

type Wrapped<T> = { data: T };

/**
 * Full InPost catalog (every method + every supported destination country),
 * independent of the merchant's market configuration.
 */
export function useDeliveryCatalog() {
  const api = useApiClient();
  return useQuery<DeliveryCatalog, Error>({
    queryKey: queryKeys.deliveryCatalog,
    queryFn: async ({ signal }) => {
      const response = await api.get<Wrapped<DeliveryCatalog>>('/admin/delivery-catalog', signal);
      return response.data;
    },
    staleTime: Infinity,
  });
}
